import React from "react";
import LegalPage from "./LegalPage";

const blocks = [
  {
    heading: "Éditeur du site",
    paragraphs: [
      "Le présent site est édité par Océana Groupe, dans le cadre du projet Diallo, réseau moderne de commerces de proximité, avec l'appui de Smartworld.",
      "Adresse, forme juridique, capital social et coordonnées complètes à compléter par l'éditeur.",
    ],
  },
  {
    heading: "Directeur de la publication",
    paragraphs: ["Le directeur de la publication est le représentant légal d'Océana Groupe. Nom et fonction à compléter."],
  },
  {
    heading: "Hébergement",
    paragraphs: ["Les informations relatives à l'hébergeur du site (raison sociale, adresse, contact) sont à compléter."],
  },
  {
    heading: "Propriété intellectuelle",
    paragraphs: [
      "La marque Diallo, le logo, la signature « Le quartier me connaît. » ainsi que l'ensemble des contenus (textes, visuels, éléments graphiques) sont protégés. Toute reproduction sans autorisation est interdite.",
    ],
  },
  {
    heading: "Contact",
    paragraphs: ["Pour toute question relative au site ou au réseau Diallo, utilisez le formulaire « Devenir Diallo » de la page d'accueil."],
  },
];

export default function MentionsLegales() {
  return <LegalPage testId="mentions-legales-page" title="Mentions légales" updated="à compléter" blocks={blocks} />;
}
